import type { FaireProductEntity } from "../../entity_types/product";

export const p_ymp92fzdn6: FaireProductEntity = {
  token: "p_ymp92fzdn6",
  type: "product",
  name: "Decaf Sugarcane Colombia Valle Del Cauca Whole Bean Coffee",
  brandToken: "b_f358njub53",
  brandName: "Comeback",
  imageUrl: "https://cdn.faire.com/fastly/f7ea19fb055aa05bec59b4bd638917dbb07eb9e21daf408d1669800432249358.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f00ec1e7662fcc5259f6a2e16f5b49fbf16bfd38c9c81386a84e2a6cc7fe7ac8.jpeg",
    "https://cdn.faire.com/fastly/d8dbf82042903a2d18d57b7833f96a227f119d7b0c4956f41f24fe7d72d91b6a.jpeg"
  ],
  priceDollars: 11,
  description: "** Currently shipping in Off-White tins. \n\nSize: 10oz Retail Tin, 2lb Bags, 5lb Bags\nTaste Notes: Pear, Jasmine, Almond\nCountry: Colombia\nLocation: Valle Del Cauca\nElevation: 1650 MASL\nVariety: Caturra, Castillo\nProcessing: Decaf\n\nLocated in a biological Conservation Corridor, Valle del Cauca lies between the National Park of Tatama and \"serrania de los paraguas\". Some years ago, this region was identified by Conservation International as one of the two main conservation corridors in Colombia. Farmers in this region are keenly aware of the importance of the preservation of natural resources, water management and friendly environmental practices.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:19.600Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
